export const skillGroups = [
  {
    label: "Frontend",
    items: ["React.js (Hooks)", "Next.js", "Angular", "JavaScript (ES6+)", "HTML5", "CSS3", "Tailwind CSS", "Responsive Design"],
  },
  {
    label: "Backend",
    items: ["Node.js", "Express.js", "REST API Development"],
  },
  {
    label: "Database",
    items: ["MongoDB", "SQL", "PostgreSQL"],
  },
  {
    label: "Languages",
    items: ["JavaScript", "Java", "C"],
  },
  {
    label: "Tools",
    items: ["Git", "GitHub", "VS Code", "Postman"],
  },
];
